import React from 'react'
import ClientDashboardLayout from '../ClientDashboardLayout'

const Index = (): JSX.Element => {
  return (
    <ClientDashboardLayout>
      <div>Client Dashboard</div>
    </ClientDashboardLayout>
  )
}

export default Index